import api from "@/services/api";

const { get, post } = api.getPrefixedMethods("requirements");

export const mainServices = {
  availableSearchOptions() {
    return get("");
  },
  sendMissingPlanDetails(missingPlanDetails) {
    return post(`add-missing-plan/`, missingPlanDetails);
  },
  searchPriorAuthForms(searchTerm) {
    return post(`search-form/`, searchTerm);
  },
  getPriorAuthForm(id, medicationDetails) {
    return post(`form/${id}`, medicationDetails);
  },
  getInsuranceProviders() {
    return get(`insurance-providers/`);
  },
  fetchDiagnosisRequirements(medication) {
    return post(`diagnosis-requirements/`, medication);
  },
  searchPharmacies(searchTerm) {
    return post("search-pharmacies/", searchTerm);
  },
  getNearestPharmacies(zipCode) {
    return post("get-pharmacies-nearby/", zipCode);
  },
  getMedicationSearchBox() {
    return get("get-medications/");
  },
  searchMedications(searchTerm) {
    return get("search-medications/", { params: { q: searchTerm } });
  },
  getClientConfig(clientCompanyId) {
    return get(`client-config/${clientCompanyId}/`);
  },
  getCurrentUserClientConfig() {
    return get("client-config/");
  },
  getClientMedications(clientCompanyId, searchTerm, pageSize = null) {
    return get(`client/${clientCompanyId}/medications/`, { params: { q: searchTerm, page_size: pageSize } });
  },
  getReferralSources(clientCompanyId, referralSource) {
    return get(`client/${clientCompanyId}/referral-sources/`, { params: { referral_source: referralSource } });
  },
  getClientProviders(clientCompanyId, params) {
    return get(`client/${clientCompanyId}/providers/`, { params });
  },
  getPayorNamesByBinPcn(clientCompanyId, bin, pcn) {
    return get(`client/${clientCompanyId}/payor-names/`, { params: { bin, pcn } });
  },
  getPayorNamesByName(clientCompanyId, payorName) {
    return get(`client/${clientCompanyId}/payor-names/`, { params: { q: payorName } });
  },
  getPayorNamesCount(clientCompanyId) {
    return get(`client/${clientCompanyId}/payor-names/`, { params: { count_only: true } });
  },
  getFaxForms() {
    return get("fax-destinations");
  },
  searchProviders(searchTerm, page = 1) {
    return get("providers", { params: { q: searchTerm, page } });
  },
  getProvidersCount() {
    return get("providers", { params: { count_only: true } });
  },
  getClientUsers(clientCompanyId, searchTerm) {
    return get(`client/${clientCompanyId}/users/`, { params: { q: searchTerm } });
  },
  getEmailTemplates(clientCompanyId) {
    return get(`client/${clientCompanyId}/email-templates/`);
  },
  getClientCompanyData(clientCompanyId, category, query = "") {
    return get(`client/${clientCompanyId}/data/`, { params: { category, q: query } });
  },
};
